<div matDialogTitle i18n>Invoice Details</div>
<mat-dialog-content>
    <div class="invoice-details">
        <div class="detail-row">
            <span class="label" i18n>Invoice Number</span>
            <span class="value">{{ invoice.reference }}</span>
        </div>
        <div class="detail-row">
            <span class="label" i18n>Type</span>
            <span class="value">{{ invoice.type }}</span>
        </div>
        <div class="detail-row">
            <span class="label" i18n>Status</span>
            <span class="value">{{ invoice.status }}</span>
        </div>
        <div class="detail-row">
            <span class="label" i18n>Date</span>
            <span class="value">{{ invoice.date | date }}</span>
        </div>
        <div class="detail-row">
            <span class="label" i18n>Total</span>
            <span class="value">{{ invoice.total | currency: invoice.currency }}</span>
        </div>
        <div class="detail-row">
            <span class="label" i18n>Sub-Total (Excl Tax)</span>
            <span class="value">{{ invoice.totalNet | currency: invoice.currency }}</span>
        </div>
        <div class="detail-row">
            <span class="label" i18n>Outstanding</span>
            <span class="value">{{ invoice.outstanding | currency: invoice.currency }}</span>
        </div>
        <div class="detail-row">
            <span class="label" i18n>Currency</span>
            <span class="value">{{ invoice.currency }}</span>
        </div>
    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="close()" i18n>Close</button>
</mat-dialog-actions>
